<template>
  <CustomDialog :visible="showDialog" @confirm="updateAccountData" @close="$emit('closeDialog')" title="Update account" >
    <template v-slot:body>
      <div class="update-form-wrapper">
        <span>Account type</span>
        <el-select v-model="accountType" filterable placeholder="Account type" class="select" value-key="account_type_name">
          <el-option
            v-for="item in accountTypeList"
            :key="item.id"
            :label="item.account_type_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <p v-if="errorMessage && !accountType" class="errorMessage">{{ errorMessage }}</p>

        <span>Min balance</span>
        <el-input type="number" class="input" placeholder="Min balance" v-model="minBalance" />
        <p v-if="errorMessage && !minBalance" class="errorMessage">{{ errorMessage }}</p>
        <span>Description</span>
        <el-input type="text" class="input" placeholder="Description" v-model="description" />
      </div>
    </template>
  </CustomDialog>
</template>

<script>
  import CustomDialog from "../CustomDialog";
  import { required } from "vuelidate/lib/validators";

  export default {

    validations: {
      accountType: {required},
      minBalance: {required},
    },


    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      account: Object
    },

    data() {
      return {
        accountType: {},
        minBalance: '',
        description: '',
        errorMessage: '',
      }
    },

    watch: {
      showDialog(value) {
        if (value) {
          this.minBalance = this.account.min_balance
          this.accountType = this.account.account_type_id
          this.description = this.account.description
        }
      },
    },

    methods: {
      async updateAccountData() {
        if (this.$v.$invalid) {
          this.errorMessage = 'All field must be filled'
          this.$v.$touch();
          return;
        }

        this.$emit('closeDialog')
        this.$emit('refreshData')

        await this.$store.dispatch('request', {
          path: 'admin/updates/accounts/data',
          body: {
            id: this.account.id,
            ac_number: this.account.account_special_number,
            min_balance: this.minBalance,
            ac_type: this.accountType,
            description: this.description
          }
        });
      }
    },

    computed: {
      accountTypeList: function () {
        return this.$store.state.accountTypeList
      }
    },

    components: { CustomDialog }
  }
</script>

<style lang="scss" scoped>
  .update-form-wrapper {
    display: flex;
    flex-direction: column;
  }

  .errorMessage {
    color: #cc3f55;
    margin-top: 0;
  }
</style>
